import { orderBy } from 'lodash';
import { Container, Col, Row } from 'react-bootstrap';

import { pageKey } from '@/routes';

import Navbar from '../components/Navbar';

import { UserManageTable, useUsers } from '@/features/users';

/**
 * == User Management(table) Page ==
 *
 * @2025/12/17
 * @returns
 */
const UserManagementPage = () => {
  const userQuery = useUsers();

  const orderedUser = orderBy(userQuery.data, ['date_created'], ['desc']);

  return (
    <Container>
      <Row>
        <Col className="bg-dark sidebar d-flex flex-column">
          <Navbar activePage={pageKey.USERS} />
        </Col>
        <Col className="my-5 ms-6 me-4">
          <h3 className="text-center">User Management</h3>
          <UserManageTable orderedUser={orderedUser} />
        </Col>
      </Row>
    </Container>
  );
};

export default UserManagementPage;
